import { Routes } from '@angular/router';
import { UserRole } from '@shared/types/user';
import { checkPermissionGuard } from '../guards/check-permission.guard';
import { loggedInAuthGuard } from '../guards/is-logged-in.guard';

export const STREAKS_ROUTES: Routes = [
  {
    path: 'streaks-games',
    loadChildren: () => import('./game/game.routes').then((r) => r.GAME_ROUTES),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'streaks-labels/:gameUuid',
    loadComponent: () =>
      import('@streaks/labels/streaks-labels/streaks-labels.component').then(
        (m) => m.StreaksLabelsComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'streaks-theme',
    loadChildren: () =>
      import('./theme/theme.routes').then((r) => r.THEME_ROUTES),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin],
    },
  },
  {
    path: 'streaks-preview',
    loadComponent: () =>
      import('@streaks/streaks-preview/streaks-preview.component').then(
        (m) => m.StreaksPreviewComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin],
    },
  },
];
